import React from 'react';
import Reviews from '../components/Reviews';

const BarberiaReviews = () => {
  return (
    <div className="barberia-reviews">
      <Reviews />
    </div>
  );
};

export default BarberiaReviews;
